import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const DashboardPage = styled.div``;

export const DashboardHeader = styled.div`
  padding: ${rem(48)} ${rem(32)};
  background-color: ${({ theme }) => theme.colors.gray800};
  color: ${({ theme }) => theme.colors.white};
  font-family: 'Pizza Hut';
`;
export const H1 = styled.h1`
  font-size: ${rem(28)};
  margin-bottom: ${rem(40)};
`;
export const QuickStart = styled.div`
  border-left: 2px solid ${({ theme }) => theme.colors.red};
  padding: 0 0 ${rem(12)} 0;
  box-sizing: border-box;
`;
export const QuickStartButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const H2 = styled.h2`
  font-size: ${rem(18)};
  margin-left: ${rem(24)};
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-top: 20px;
  padding-left: 30px;
  color: ${({ theme }) => theme.colors.gray700};
  select {
    width: ${rem(300)};
  }
`;

export const DashboardLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
